const IntroComponent = (props) => {
  const { title, des, titleSize = 'lg', className } = props;

  return (
    <div className={`px-4 md:px-0 ${className}`}>
      <p className={`text-${titleSize} font-[800]`}>{title}</p>
      <p className="text-sm text-02-dim-gray">{des}</p>
    </div>
  );
};

export default IntroComponent;
